export default {
    title: 'Ready to begin?',
    subtitle: 'Just follow the steps to launch your Self-Assessment!',
    selectReviewee: {
        stepTitle: 'Select Colleague to Review',
    },
    templateSelection: {
        stepTitle: 'Choose a Template to Complete',
    },
    questionnaireCreation: {
        stepTitle: 'Build your Review',
    },
    scheduleCreation: {
        stepTitle: 'Launch the Self-Assessment',
    },
};
